import { FC, ReactNode } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  createStyles,
  makeStyles,
  Typography,
} from "@material-ui/core";

import theme from "theme";

export interface OverviewCardProps {
  icon: ReactNode;
  label: string;
  value: string;
  color: string;
}

interface StyleProps {
  color: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[3],
      maxHeight: "150px",
    },
    cardHeader: {
      display: "flex",
      flexDirection: "column",
      paddingBottom: theme.spacing(0),
      alignItems: "center",
      "& .MuiCardHeader-avatar": {
        marginRight: 0,
      },
    },
    avatar: ({ color }: StyleProps) => ({
      marginBottom: theme.spacing(1),
      backgroundColor: color,
    }),
    cardContent: {
      padding: theme.spacing(0),
    },
    value: {
      fontSize: "1.7rem",
      textAlign: "center",
      [theme.breakpoints.only("md")]: {
        fontSize: "1.5rem",
      },
    },
    subheader: {
      fontSize: "0.7rem",
    },
  }),
);

const DashboardOverviewCard: FC<OverviewCardProps> = ({
  icon,
  label,
  value,
  color,
}) => {
  const classes = useStyles({ color });

  return (
    <Card className={classes.card}>
      <CardHeader
        classes={{ root: classes.cardHeader }}
        avatar={<Avatar className={classes.avatar}>{icon}</Avatar>}
        subheader={
          <Typography component="span" className={classes.subheader}>
            {label}
          </Typography>
        }
      />
      <CardContent className={classes.cardContent}>
        <Typography className={classes.value}>{value}</Typography>
      </CardContent>
    </Card>
  );
};

export default DashboardOverviewCard;
